export const e2eNotificationsSelector = state =>
  state.administration.e2eHealthcheck.notifications;

export const e2eNotificationsLoadingSelector = state =>
  state.administration.e2eHealthcheck.isLoading;

export const e2eNotificationsUpdatingSelector = state =>
  state.administration.e2eHealthcheck.updatingJobIds;
